var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"centered":"","title":_vm.title,"size":"xl","id":_vm.target,"hide-footer":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }